import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function UpdateIcon(props: IconProps) {
    return <Icon {...props} iconKey={"update"}/>
}
